<template>
    <div class="table-filter pt-4 pb-4">
        <header class="large-title text-center" v-if="table_title !== undefined">{{table_title}}</header>
        <div class="category-area tab-selector" v-if="categoryCount > 1">
            <span v-for="(category, categoryId) in table_data"
                  class="category"
                  :class="{'selected' : selectedCategory === categoryId}"
                  @click="selectCategory(categoryId)"
            >
                {{category.title}}
            </span>
        </div>
        <div class="filter-input pt-4 pb-4">
            <span class="filter">
                <input type="text" size="45" v-model="filterTerm" placeholder="Busca por itens da lista">
                <div class="search-icon">
                    <svg width="28px" height="28px" viewBox="0 0 28 28" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns="http://www.w3.org/2000/svg">
                      <g id="ico-buscar">
                        <g id="ico-search">
                          <path d="M13.8592 13.0189L14.7942 13.0189L20.7 18.9365L18.9365 20.7L13.0189 14.7942L13.0189 13.8592L12.6993 13.5278C11.3501 14.6877 9.59846 15.3859 7.69297 15.3859C3.44408 15.3859 0 11.9419 0 7.69297C0 3.44408 3.44408 0 7.69297 0C11.9419 0 15.3859 3.44408 15.3859 7.69297C15.3859 9.59846 14.6877 11.3501 13.5278 12.6993L13.8592 13.0189ZM2.36707 7.69297C2.36707 10.64 4.74597 13.0189 7.69297 13.0189C10.64 13.0189 13.0189 10.64 13.0189 7.69297C13.0189 4.74597 10.64 2.36707 7.69297 2.36707C4.74597 2.36707 2.36707 4.74597 2.36707 7.69297Z" transform="translate(3.610547 3.6000001)" id="Shape" fill="#00358E" fill-rule="evenodd" stroke="none" />
                          <path d="M0 0L27.9 0L27.9 27.9L0 27.9L0 0Z" transform="translate(0.010546875 0)" id="Path" fill="none" stroke="none" />
                        </g>
                      </g>
                    </svg>
                </div>
            </span>
        </div>
        <table>
            <thead>
            <tr>
                <th>{{table_data[selectedCategory].title}}</th>
                <th @click="changeDateOrder" class="date-order">Data <span :class="{'asc' : orderDates === 0, 'desc' : orderDates === 1}">&larr;</span></th>
            </tr>
            </thead>
            <tbody>
            <tr
                v-for="(item,index) in paginatedItems"
                v-if="item!==undefined"
                :class="{'odd-row' : (index % 2) === 0}"
            >
                <td>
                    <a :href="item.target">{{item.title}}</a>
                </td>
                <td>
                    {{formatDate(item.date)}}
                </td>
            </tr>
            </tbody>
        </table>
      <div class="pagination-pages pt-4 pb-4">
        <span v-if="currentPage>1" class="pagination-arrow previousPage" @click="goToPrev"></span>
        <span v-text="page < totalPages-1 && page+1 !== currentPage ? (page+1)+',' : page+1"
              @click="goToPage(page+1)"
              v-for="page in paginationPages[0]"
              class="selectPage"
              :class="{'selected' : currentPage === page+1}">
            </span>
        <span v-if="paginationPages[1] !== undefined && currentPage > 5">...</span>
        <span v-text="page < totalPages-1 && page+1 !== currentPage ? (page+1)+',' : page+1"
              @click="goToPage(page+1)"
              v-if="paginationPages[1] !== undefined"
              v-for="page in paginationPages[1]"
              class="selectPage"
              :class="{'selected' : currentPage === page+1}">
            </span>
        <span v-if="paginationPages[1] !== undefined && currentPage < totalPages-4">...</span>
        <span v-text="page < totalPages-1 && page+1 !== currentPage ? (page+1)+',' : page+1"
              @click="goToPage(page+1)"
              v-if="paginationPages[2] !== undefined"
              v-for="page in paginationPages[2]"
              class="selectPage"
              :class="{'selected' : currentPage === page+1}">
            </span>
        <span v-if="currentPage<totalPages" class="pagination-arrow nextPage" @click="goToNext"></span>
      </div>
    </div>
</template>

<script>
export default {
    props:{
        table_title: String,
        table_data: Object,
        rows: Number
    },
    data: () => {
        return {
            tableItems:Object,
            filteredItems:Object,
            selectedCategory:'',
            filterTerm:'',
            currentPage: 1,
            totalPages: 0,
            orderDates: 0 // 0 = asc - 1 = desc
        }
    },
    computed:{
        selectedLanguage:function(){
            return this.$root.sharedState.language;
        },
        rowsCount:function(){
            return this.rows === undefined ? 10 : +this.rows;
        },
        categoryCount:function(){
            return Object.keys(this.table_data).length;
        },
        paginatedItems:function(){
            return this.paginate();
        },
        paginationPages:function(){
            let chunks = [];
            chunks[0] = [];
            chunks[1] = [];
            chunks[2] = [];
            chunks[0].push(0,1,2);
            if(this.totalPages <= 3){
                chunks[1] = undefined;
                chunks[2] = undefined;
                chunks[0] = [];
                for(let i = 0; i <= this.totalPages; i++)
                    if(i<=this.totalPages)
                        chunks[0].push(i)
            }else if(this.totalPages <=6){
                chunks[1] = undefined;
                for(let i = 3; i<= this.totalPages; i++)
                    if(i>2)
                        chunks[2].push(i);
            }else{
                chunks[2].push(this.totalPages-2, this.totalPages-1, this.totalPages);
                if(this.currentPage-1 > 1 && this.currentPage-1 < this.totalPages-2)
                    for(let i = this.currentPage -2; i<= this.currentPage; i++)
                        if(i > 2 && i < this.totalPages-2)
                            chunks[1].push(i)
            }
            return chunks;
        }
    },
    methods:{
        paginate(){
            let startIndex = this.rowsCount * (this.currentPage -1);
            let items = [];
            this.filterItems();
            for(let i=0; i<Object.keys(this.filteredItems).length;i++){
                if(this.filteredItems[i] !== undefined)
                    items.push(this.filteredItems[i]);
            }
            this.orderByDate(items);
            return items.slice(startIndex, startIndex+this.rowsCount);
        },
        selectCategory(category){
            this.selectedCategory = category;
            this.tableItems = this.table_data[category].items;
            this.filteredItems = Object.assign({}, this.tableItems);
        },
        filterItems(){
            this.filteredItems = Object.assign({}, this.tableItems);
            if(this.filterTerm === '') return;
            this.filteredItems = Object.keys(this.filteredItems).reduce((r,e) => {
                if(this.filteredItems[e].title[this.selectedLanguage].toLowerCase().includes(this.filterTerm.toLowerCase())) r[e] = this.filteredItems[e];
                return r;
            }, {});
        },
        changeDateOrder(){
            this.orderDates = this.orderDates === 0 ? 1 : 0;
        },
        orderByDate(list){
            list = list.sort((k1, k2)=>{
                if(this.orderDates === 0){
                    if(k1.date < k2.date) return -1
                    else if(k1.date > k2.date) return +1
                    else return 0
                }else{
                    if(k1.date > k2.date) return -1
                    else if(k1.date < k2.date) return +1
                    else return 0
                }
            })
            return list;
        },
        formatDate(milliseconds){
            return new Intl.DateTimeFormat(this.selectedLanguage).format(new Date(milliseconds))
        },
        nextPage(){
            this.changePage(this.currentPage + 1);
        },
        previousPage(){
            this.changePage(this.currentPage - 1);
        },
        changePage(pageNumber){
            this.currentPage = pageNumber < 1 ? 1 : (pageNumber > this.totalPages+1 ? this.totalPages+1 : pageNumber);
        }
    },
    beforeMount(){
        this.selectCategory(Object.keys(this.table_data)[0]);
        this.totalPages = Math.floor(Object.keys(this.filteredItems).length / +this.rowsCount);
        window.tabela = this;
    }
}
</script>
